import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { useGET_mySchoolQuery } from "redux/api/mySchoolApi"
import { BRIGHT_GREEN, PRIMARY_GREEN } from 'utils/customizedTheme'
import { GOALBANK_ITEM_TYPES, goalbankSelectionItems, goalbankSelectionStandards } from "utils/helpers"

interface IProps {
  goalbankSelection: any,
  curriculumSelection: any
}

const GoalbankSelectionTemplate: FC<IProps> = ({ goalbankSelection, curriculumSelection }) => {
  const { t } = useTranslation()
  const { isFetching: schoolLoading, data: schoolData } = useGET_mySchoolQuery()

  return (<>


    <div className='border-grid'>
    {
      schoolData && goalbankSelection &&  <div className="border-grid-td">
        <b>{schoolData.curriculum ? t(`school-curriculum.${schoolData.curriculum}`) : t('curriculum')}</b>
        <div style={{ paddingTop: '10px' }}>{ goalbankSelectionStandards(goalbankSelection).join(", ") }</div>
      </div> 
    }

    {
      goalbankSelection && Object.keys(GOALBANK_ITEM_TYPES).map(section => 
        goalbankSelectionItems(goalbankSelection,section).length>0 && <div className="border-grid-td"  
          key={`${section}`}>
        <b>{section==='course_chapters' ? t('goalbank.learning-objectives') : `${GOALBANK_ITEM_TYPES[section].title}`}</b>

        <div style={{ paddingTop: '10px' }}>
        {
            GOALBANK_ITEM_TYPES[section].type === 'units' 
            ? <>
              { goalbankSelectionItems(goalbankSelection, section).map(unit => 
                <div key={`unit_${unit.id}`} style={{ 
                    borderBottom: '1px dashed gray',
                    paddingBottom: '20px',
                    marginBottom: '20px' 
                  }}>
                  <div>{unit.sort_order}. {unit.title}</div>

                  {goalbankSelectionItems(goalbankSelection, "course_chapters")
                    .filter(item => item.unit === unit.id).length > 0 &&
                    <div style={{ marginTop: '20px', }}>
                      <div>{t('goalbank.learning-progression')}:</div>
                      <ul>{ goalbankSelectionItems(goalbankSelection, "course_chapters")
                        .filter(item => item.unit === unit.id)
                        .map(item => 
                      <li key={`lesson_objective_${item.id}`}>{item.title} - {item.goal}</li>) 
                      }
                      </ul>
                    </div>
                  }
                </div>
              )}
            </>
            : <ul>{ goalbankSelectionItems(goalbankSelection, section).map(item => 
              <li key={item.id}>{item.title}{GOALBANK_ITEM_TYPES[section].display_code && <> - {item.goal_code}</>}</li>) }</ul>
          }


        </div>
      </div>  
      )
    }


    {curriculumSelection && Object.keys(curriculumSelection).length > 0 &&
        Object.keys(GOALBANK_ITEM_TYPES)
          .filter(section => goalbankSelectionItems(curriculumSelection, section).length>0)
          .map(section => 
             <div className="border-grid-td" key={`${section}`}>
                <b>{GOALBANK_ITEM_TYPES[section].title}</b>
                <div style={{ paddingTop: '10px' }}>
                  <ul>{ goalbankSelectionItems(curriculumSelection, section).map(item => 
                      <li key={item.id}>
                          {GOALBANK_ITEM_TYPES[section]["code_field"] && 
                            item[GOALBANK_ITEM_TYPES[section]["code_field"]] && 
                           <b>({item[GOALBANK_ITEM_TYPES[section]["code_field"]]}) </b>}

                            {item.title}

                            {GOALBANK_ITEM_TYPES[section].has_description && item.description && <div>
                              <i>{item.description}</i>
                             </div>}
                      </li>) }
                    </ul>
                </div> 
              </div>
             )
      } 
    </div>

  </>)
}

export default GoalbankSelectionTemplate
